import { render, staticRenderFns } from "./SafetyProduct.vue?vue&type=template&id=c456adba&scoped=true&"
import script from "./SafetyProduct.vue?vue&type=script&lang=js&"
export * from "./SafetyProduct.vue?vue&type=script&lang=js&"
import style0 from "./SafetyProduct.vue?vue&type=style&index=0&id=c456adba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c456adba",
  null
  
)

export default component.exports